module.exports = function () {
    return new Worker(__webpack_public_path__ + "f6917ee8a8961912d818.worker.js");
};
